import {Component} from '@angular/core';
import {Angulartics2GoogleTagManager} from 'angulartics2';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {TranslateService as TranslateProvider} from '@ngx-translate/core';
import {AngularticsGCLOG, ApiService, ParserService, TranslateService} from '@gallaghercp/core-frontend';
import {throwError} from 'rxjs';

@Component({
    standalone: false,
    selector: 'core-root',
    template: '<router-outlet></router-outlet>'
})

export class AppComponent {
    title = 'core-palo-alto';

    constructor(
        private translate: TranslateService,
        private translateProvider: TranslateProvider,
        private parser: ParserService,
        private api: ApiService,
        public router: Router,
        public gtm: Angulartics2GoogleTagManager,
        public gclog: AngularticsGCLOG,
    ) {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            // Override for CloudAcademy
            this.api.setServiceZone(2);
        }

        document.addEventListener('wscr.consent', ((event: CustomEvent) => {
            if (event.detail.consent[3]) {
                gtm.startTracking();
            }
        }) as EventListener);

        try {
            if (this.parser.getCookie('wscr.consent')
                && (this.parser.getCookie('wscr.consent') as any).consent[3]) {
                gtm.startTracking();
            }
        } catch (err) {
            throwError('Cannot initialise GTM');
        }

        gclog.startTracking();

        translateProvider.setDefaultLang(translate.getDefaultLanguage());
        translate.getLanguages().subscribe((languages: any[]) => {
            translateProvider.addLangs(
                languages.map(language => {
                    return language.code;
                })
            );
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                try {
                    gtm.pageTrack(event.urlAfterRedirects);
                    gclog.pageTrack(event.urlAfterRedirects);
                } catch (err) {
                    console.log(err);
                }
            }
        });

    }

}
